import React, { useState } from "react";
import "../css/comites.css";
import james from "../img/colaplamed/james.png";
import vice from "../img/colaplamed/vicepresidente.png";

const organizador = [
  {
    nombre: "Omar Malagón Avilés",
    cargo: "Presidente",
    institucion: "Universidad Técnica Particular de Loja, Ecuador",
    foto: "https://sica.utpl.edu.ec/media/uploads/docentes/fotos/web/low/1725761322_low.jpg"
  },
  {
    nombre: "Mario Simirgiotis",
    cargo: "Vicepresidente 1",
    institucion: "Universidad Austral, Valdivia, Chile",
    foto: vice,
  },
  {
    nombre: "Nixon Cumbicus",
    cargo: "Secretario general",
    institucion: "Universidad Técnica Particular de Loja",
    foto: "https://sica.utpl.edu.ec/media/uploads/docentes/fotos/web/low/1103804207_low.jpg"
  },
  {
    nombre: "James Calva",
    cargo: "Tesorero",
    institucion: "Universidad Técnica Particular de Loja",
    foto: james,
  }
];

const otrosComites = [
  {
    titulo: "Comité Científico Nacional",
    miembros: [
      "Presidente: María Elena Cazar (Universidad de Cuenca)",
      "Vicepresidente: Gianluca Gilardoni (Universidad Técnica Particular de Loja)",
      "Secretaria comité científico nacional: Yesenia Maldonado (Universidad Técnica Particular de Loja)"
    ]
  },
  {
    titulo: "Comité Científico Latinoamericano",
    miembros: [
      "Presidente: Mayar Ganoza (Universidad Nacional de Trujillo, Perú)",
      "Vicepresidente: Ninoska Flores (Universidad Mayor de San Andrés, Bolivia)",
      "Secretario: Oscar Sánchez-Aguirre (Universidad Veracruzana, México)"
    ]
  },
  {
    titulo: "Comité de apoyo Latinoamericano",
    miembros: [
      "Roberto Ybañez (Universidad Nacional de Trujillo, Perú) – presidente SOLAPLAMED",
      "José L. Martínez (Universidad de Santiago de Chile) – secretario permanente SOLAPLAMED",
      "Fidel Torres (Perú) – past-presidente XII COLAPLAMED"
    ]
  },
  {
    titulo: "Directorio SOLAPLAMED",
    miembros: [
      "Presidente: Roberto Ybañez – Perú",
      "Vicepresidente: Fidel Torres – Perú",
      "Secretario: José L. Martínez – Chile",
      "Tesorero: Víctor Villarreal – Perú",
      "Leticia Cano – México",
      "Fernando Echeverri – Colombia",
      "Ricardo de Albuquerque – Brasil",
      "Maite Rodríguez – Chile",
      "Jeremías Puentes – Argentina"
    ]
  }
];

export default function Comites() {
  const [activo, setActivo] = useState(null);

  const toggle = (index) => {
    setActivo(activo === index ? null : index);
  };

  return (
    <div className="comites-container">

      {/* Comité Organizador */}
      <h2 className="titulo-seccion">Comité <b> Organizador</b></h2>

      <div className="organizador-grid">
        {organizador.map((persona, i) => (
          <div key={i} className="persona-card">
            <img src={persona.foto} alt={persona.nombre} />
            <h3>{persona.nombre}</h3>
            <p className="cargo">{persona.cargo}</p>
            <p className="inst">{persona.institucion}</p>
          </div>
        ))}
      </div>

      {/* Acordeones */}
      <div className="acordeones">
        {otrosComites.map((comite, index) => (
          <div key={index} className="acordeon">
            
            <button
              className="acordeon-header"
              onClick={() => toggle(index)}
            >
              {comite.titulo}
              <span>{activo === index ? "-" : "+"}</span>
            </button>

            <div className={`acordeon-body ${activo === index ? "activo" : ""}`}>
              <ul>
                {comite.miembros.map((m, i) => (
                  <li key={i}>{m}</li>
                ))}
              </ul>
            </div>

          </div>
        ))}
      </div>

    </div>
  );
}